import script from "./EditSchoolForm.vue?vue&type=script&setup=true&lang=js"
export * from "./EditSchoolForm.vue?vue&type=script&setup=true&lang=js"

import "./EditSchoolForm.vue?vue&type=style&index=0&id=419803e6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-419803e6"]])

export default __exports__